enum ContainerType {
  FINAL,
  PARENT,
}

export default ContainerType;
